const getWeeks = (days: number) => Math.ceil(days / 7);
export default getWeeks;
